/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{z-index:100!important}.js_modal[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:21px;text-align:center}.js_modal[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:100%}\n/*# sourceMappingURL=dialog.component.css.map*/"];
export { styles as styles };
